<template>
  <vs-sidebar
      click-not-close
      parent="#view-detail"
      :hidden-background="true"
      class="full-vs-sidebar email-view-sidebar items-no-padding sidebar-view-custom sidebar-view-ask-analyst"
      :class="{
        'sidebar-view-custom-reduced': reduceFilterSidebar, 
        'sidebar-view-custom-mobile': !isDesktop,
        'ask-analyst-ticker-top': canDisplayTicker && tickerViewAtTheTop,
        'ask-analyst-ticker-bottom': canDisplayTicker && !tickerViewAtTheTop
      }"
      v-model="isSidebarActive"
      position-right
    >
      <div
        id="informative-view-content"
        class="mail-sidebar-content px-0 sm:pb-6 h-full"
      >
      <!-- <feather-icon
        icon="ChevronLeftIcon"
        @click.stop="onBack"
        class="cursor-pointer mr-4 back-button back-button-ask-the-analyst"
        svg-classes="w-6 h-6"
      ></feather-icon> -->
        <!-- <VuePerfectScrollbar
          id="analyst-scroll"
          class="custom-scroll-content-analyst"
          :settings="settings"
          ref="analystPS"
        >
        </VuePerfectScrollbar> -->
        <div class="content-form h-full">
            <!-- <feather-icon
              icon="ChevronLeftIcon"
              @click.stop="onBack"
              class="cursor-pointer mr-4 back-button back-button-ask-the-analyst"
              svg-classes="w-6 h-6"
            ></feather-icon> -->
            <div class="vx-col w-full h-full">
              <vx-card style="height: auto">
                <div 
                  class="vx-card__title m-4 flex" 
                  style="justify-content: space-between;"
                  :class="{ 'ask-the-analyst-title': !isDesktop }"
                >
                  <!-- <h2 class="text-center">{{analystTitle}}</h2> -->
                  <!-- <div class="flex">
                  </div> -->
                  <h2 class="primary">{{analystTitle}}</h2>
                  <h4 class="ask-analyst">{{commodityName}}</h4>
                  <span class="remaining-questions">{{$t('ASK_THE_ANALYST').Remaining_Questions}} {{numQuestion}}</span>
                </div>
                <!-- <div class="vx-row">
                  <div class="vx-col w-full m-5 mb-0">
                    <vs-input
                      class="w-full hidden"
                      icon-no-border
                      :label="$t('ASK_THE_ANALYST').Field_Commodity"
                      v-model="commodityName"
                      
                    />
                      <h4 class="ask-analyst">{{commodityName}}</h4>
                      <span class="remaining-questions">{{$t('ASK_THE_ANALYST').Remaining_Questions}} {{numQuestion}}</span>
                  </div>
                </div> -->
                <div class="vx-row p-8 pt-0 pb-0" v-if="false">
                  <ask-analyst-hist :hist="hist"></ask-analyst-hist>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-full m-5 mt-0" style="position: relative">
                    <vs-textarea
                      class="w-full custom-input-textarea"
                      icon-pack="feather"
                      icon="icon-message-circle"
                      icon-no-border
                      :label="$t('ASK_THE_ANALYST').Field_Question"
                      v-model="form.question"
                      height="80"
                      :disabled="!questionAvailable"
                    />
                    <vs-button color="primary"  class="btn-send-question" @click="onSubmit" :disabled="!questionAvailable">{{$t('BUTTONS').Send}}</vs-button>
                  </div>
                </div>
               
              </vx-card>
            </div>
          </div>
      </div>
</vs-sidebar>
  
</template>

<script>
import askAnalystService from "../../../providers/askAnalystService";
import messagesNotifyHelper from "../../../helpers/messages-notify-helper";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import messageDialogHelper from '../../../helpers/message-dialog-helper';
import { EventBus } from '../../../event-bus';
import AppConstants from '../../../appConstants';
import AskAnalystHist from './AskAnalystHist.vue';

export default {
  components: {
    // VuePerfectScrollbar,
    AskAnalystHist
  },
  props: {
    commodityName: "",
    currentCommodity: null,
    currentContent: null,
    reduceFilterSidebar: Boolean,
    isDesktop: Boolean,
    isSidebarActive: {
      type: Boolean,
      required: true
    },
  },
  created() {
    this.getQuestionsAvaliable();
    // console.log('[askAnalyst]',this.currentCommodity);

    this.form.email = this.$store.state.AppActiveUser.email;
    this.form.name = this.$store.state.AppActiveUser.nome;
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      form: {
        email: "",
        name: "",
        question: "",
        subjectCode: null
      },
      questionAvailable: false,
      numQuestion: 0,
      hist: []
    };
  },
  computed: {
    tickerViewAtTheTop() {
      return this.$store.state.tickerViewAtTheTop;
    },
    canDisplayTicker() {
      return this.$store.state.canDisplayTicker;
    },
    analystTitle() {
      if (this.currentCommodity.id == 61) {
        return this.$t('ASK_THE_ANALYST').TitleHedge;
      }
      return this.$t('ASK_THE_ANALYST').Title;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    isCardView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
    },
  },
  methods: {
    getMoreQuestion() {
      messageDialogHelper.displayGetMoreQuestionMessage(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, this.$t('HELP_ATTENDANCE').NoRights_Text_GetMoreQuestions);
      });
    },
    getQuestionsAvaliable() {
      if (this.isAuthenticated) {
        this.hist = [];
        const params = new URLSearchParams();
        params.append('subjectCode', this.currentCommodity.id);
        askAnalystService
          .getQuestionAvailable(params)
          .then(data => {
            this.numQuestion = data.numQuestions; 
            this.questionAvailable = data.availableQuestions;
            this.hist = data.hist;
          });
      }
    },
    onSubmit() {
      this.form.subjectCode = this.currentCommodity.id;
      askAnalystService
        .askToAnalyst(this.form, new URLSearchParams())
        .then(() => {
          this.form.question = "";
          messagesNotifyHelper.successNotify(
            this.$t('TOAST_NOTIFICATIONS').askAnalystTitle,
            this.$t('TOAST_NOTIFICATIONS').askAnalystSuccess
          );
          this.getQuestionsAvaliable();
          // this.onBack();
        })
        .catch(error => console.log(error));
    },
    onBack() {
      this.$emit("backPage", this.currentContent);
    },
    clearForm() {
      this.form.email = ""; 
      this.form.name = "";
      this.form.question = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.content-form {
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 10px;
  // position: fixed;
  width: 100%;
  justify-content: center;
}
.custom-scroll-content-analyst {
  height: calc(100% - 100px);
}
.sidebar-view-custom-mobile {
  .vs-sidebar {
    margin-left: 50px;
    width: 100%; 
    margin-top: 0px;
  }
} 

.ask-the-analyst-title {
  flex-direction: column;
  padding-top: 2rem;
}

.ask-the-analyst-title h2 {
  margin-left: 0;
}



</style>
